module.exports = fox._r("images/cbCpWhite.png", __webpack_public_path__ + "_/_/_/root/images/cbCpWhite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/cbCpWhite.png
// module id = 52
// module chunks = 4